"use client"; // Marking this as a Client Component
import Image from "next/image";
import style from "@/styles/FullBanner.module.scss";

const FullBanner = (props) => {
  const { title, description, image } = props.data || {};

  return (
    <>
      <style jsx>
        {`
          .main-banner {
            display: flex;
            align-items: center;
            background-image: linear-gradient(45deg, rgba(248, 227, 197, 0.8), rgba(255, 223, 205, 0.8)), url(${image});
            height: 50vh;
            min-height: 250px;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: top;
          }
        `}
      </style>

      <section className="main-banner">
        <div className={`container`}>
          <div className={`${style["bannerrow"]} ${style["commonbannermaindiv"]} `}>
            <div className={`${style["bannerleft"]}`}>
              <div className={`${style["contentbox"]}`}>
                <h1 className={`${style["bannertitle"]}`}>{title}</h1>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FullBanner;
